import Welcome from "../../entities/Welcome/ui/Welcome";
import styles from "./MainPage.module.scss";

const MainPage = () => {
    return ( 
        <main className={styles.main}>
        <div className={styles.container}>
            <Welcome/>
        </div>
      </main>
     );
}
 
export default MainPage;